<template>
  <!-- 模版页面 -->
  <div class="test-box">
    <!-- header头部 -->
    <header></header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="before_type" label="变更前类型" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.before_type === 1" type="info">普通用户</el-tag>
            <el-tag v-if="row.before_type === 2" type="success">主播</el-tag>
            <el-tag v-if="row.before_type === 7" type="success"
              >主播（新）</el-tag
            >
            <el-tag v-if="row.before_type === 3" type="primary"
              >测试账号</el-tag
            >
            <el-tag v-if="row.before_type === 4" type="warning">代理</el-tag>
            <el-tag v-if="row.before_type === 5" type="warning"
              >代&nbsp;理</el-tag
            >
            <el-tag v-if="row.before_type === 6" type="warning"
              >试用期代理</el-tag
            >
            <el-tag v-if="row.before_type === 9" type="warning"
              >代&nbsp;&nbsp;理</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="after_type" label="变更后类型" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.after_type === 1" type="info">普通用户</el-tag>
            <el-tag v-if="row.after_type === 2" type="success">主播</el-tag>
            <el-tag v-if="row.after_type === 7" type="success"
              >主播（新）</el-tag
            >
            <el-tag v-if="row.after_type === 3" type="primary">测试账号</el-tag>
            <el-tag v-if="row.after_type === 4" type="warning">代理</el-tag>
            <el-tag v-if="row.after_type === 5" type="warning"
              >代&nbsp;理</el-tag
            >
            <el-tag v-if="row.after_type === 6" type="warning"
              >试用期代理</el-tag
            >
            <el-tag v-if="row.after_type === 9" type="warning"
              >代&nbsp;&nbsp;理</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="变更时间" align="center">
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
  </div>
</template>

<script>
import {
  mapActions,
  mapMutations,
  mapState
} from 'vuex'
import http, {
  server,
  api,
  delApiData,
  getApiData,
  postApiData,
  patchApiData
} from '@/http'

export default {
  props: {
    id: {
      type: String,
      default: undefined
    },
  },
  data() {
    return {
      loading: false, //加载动画
      query: {
        page: 1
      },
      dataList: undefined, //数据列表
      dataMeta: undefined, //底部跳转页面条
    }
  },
  computed: {
    user_id() {
      return this.id
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      let params=this.query
      getApiData(`user_type_record/${this.user_id}`,params).then(res => {
        if (res) {
          this.dataList = res.data
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
  }

}

</script>
<style lang="less" scoped>
.debris_formula_config-box {
  header {
  }

  .body-box {
    // width: 800px;
  }
}
</style>
